import firebase from 'firebase/app'; // Only needs the app folder
import 'firebase/database';
import 'firebase/storage';
import 'firebase/auth';
import { DB_CONFIG } from './config';

// Initializes the firebase
const Firebase = firebase.initializeApp(DB_CONFIG);

//
export const db = Firebase.database();
export const storage = Firebase.storage();
export const auth = firebase.auth();

// Assings a reference to the books list
export const booksRef = db.ref().child('books');